<template>
  <div class="loading-layer" @touchmove.prevent>
    <img src="../assets/img/loading.gif" class="loading-logo abs" />
    <div class="progress-bar">
      <div class="grow-bar" :style="{ width: progress + '%' }"></div>
      <div class="progress-num">{{ pTxt }}%</div>
    </div>
    <transition name="fade">
      <img
        v-if="pTxt == 100"
        @click="startVideo"
        class="start-btn abs"
        src="../assets/img/start_btn.png"
        alt=""
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: "LoadingLayer",
  props: ["progress"],
  computed: {
    pTxt() {
      return Math.floor(this.progress).toString();
    }
  },
  methods: {
    startVideo() {
      this.$emit("startvideo");
    }
  }
};
</script>

<style lang="less" scoped>
.loading-layer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/img/loading_bg.jpg") no-repeat center;
  background-size: 100% 100%;
  background-color: #fff;
  z-index: 1000;
  .loading-logo {
    width: 368px;
    height: 220px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  .progress-bar {
    width: 450px;
    height: 20px;
    background-color: transparent;
    margin: 45px auto 40px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -100%);
    border-radius: 22px;
    .grow-bar {
      opacity: 0;
      position: absolute;
      background-color: #f6c300;
      height: 100%;
      border-radius: 22px;
    }
    .progress-num {
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: -100px;
      font-size: 40px;
      color: #388baa;
      font-weight: bold;
    }
  }
  .start-btn {
    width: 415px;
    height: 80px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 100%);
  }
}
</style>
